import React from 'react'


const Video = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         {...props}
         viewBox="0 0 32 32"

         preserveAspectRatio="xMidYMid">
        <path d="M16 32C7.178 32 0 24.823 0 16 0 7.178 7.178 0 16 0s16 7.178 16 16c0 8.823-7.178 16-16 16zm0-30.001C8.28 1.999 2 8.28 2 16c0 7.719 6.28 14 14 14s14-6.281 14-14c0-7.72-6.28-14.001-14-14.001zm7.479 14.879l-11 6a.992.992 0 0 1-.989-.018A1 1 0 0 1 11 22V10a1 1 0 0 1 1.479-.878l11 6a1 1 0 0 1 0 1.756zM13 11.685v8.63L20.912 16 13 11.685z"
              fillRule="evenodd"/>
    </svg>

export default Video


// WEBPACK FOOTER //
// ./src/components/_common/_icons/Video.js